import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

class PopUpMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false,
    };
  }

  closeMenu = () => {
    this.setState({ open: false, anchorEl: null });
  }

  renderControlListButton() {
    const {
      user,
      openReportDialog,
    } = this.props;

    if (!user || !user.userName) {
      return null;
    }

    // this is a WIP prototype for Tinschert CNH
    if (!user.userName.includes('abholung-cnh') && !user.userName.includes('waiter@poolhouse.at') && !window.location.href.includes('localhost')) {
      return null;
    }

    return (
      <MenuItem onClick={() => { openReportDialog(); this.closeMenu(); }}>Bericht drucken</MenuItem>
    );
  }

  render() {
    const {
      classes,
      logoutFunc,
      openArticleListDialog,
      editRoutePlanning,
      startNewRoutePlanning,
      finishRoutePlanning,
      isRoutePlanning,
      openRouteDialog,
      openSettingsDialog,
      localSettings,
      user,
      toggleProductDialog,
      downloadLabels,
      printLabels,
    } = this.props;

    return (
      <div className={classes.root} >
        <IconButton onClick={e => this.setState({ open: true, anchorEl: e.currentTarget })}>
          <MenuIcon fontSize="default" />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={this.state.open}
          onClose={this.closeMenu}
        >
          {user ? (<span style={{ paddingLeft: 16, color: '#777' }}>{user.userName}</span>) : null}
          <MenuItem onClick={() => { toggleProductDialog(true); this.closeMenu(); }}>Produkte sperren</MenuItem>
          <MenuItem onClick={() => { openArticleListDialog(); this.closeMenu(); }}>Artikelliste anzeigen</MenuItem>

          {this.renderControlListButton()}
          {localSettings.labelPrinting ? <div>
            <MenuItem onClick={() => { downloadLabels(); this.closeMenu(); }}>{'Etiketten herunterladen'}</MenuItem>     
            <MenuItem onClick={() => { printAllLabels(); this.closeMenu(); }}>{'Etiketten drucken'}</MenuItem>            
          </div> : null}
          {localSettings.enableRouteplanning ? <div>
            <MenuItem onClick={() => { isRoutePlanning ? finishRoutePlanning() : editRoutePlanning(); this.closeMenu(); }}>{isRoutePlanning ? 'Route speichern' : 'Route bearbeiten'}</MenuItem>
            <MenuItem onClick={() => { isRoutePlanning && finishRoutePlanning(); openRouteDialog(); this.closeMenu(); }}>Route berechnen</MenuItem>
            <MenuItem onClick={() => { startNewRoutePlanning(); this.closeMenu(); }}>Route zurücksetzen</MenuItem>
          </div> : null}
          <MenuItem onClick={() => { openSettingsDialog(); this.closeMenu(); }}>Einstellungen</MenuItem>
          <MenuItem onClick={() => { logoutFunc(); this.closeMenu(); }}>Logout</MenuItem>
        </Menu>
      </div >
    );
  }
}

const styles = theme => ({
  root: {
  },
  button: {
    fontSize: theme.order.buttons.fontSize,
  },
});

PopUpMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  startNewRoutePlanning: PropTypes.func.isRequired,
  finishRoutePlanning: PropTypes.func.isRequired,
  editRoutePlanning: PropTypes.func.isRequired,
  isRoutePlanning: PropTypes.bool.isRequired,
  openRouteDialog: PropTypes.func.isRequired,
  logoutFunc: PropTypes.func.isRequired,
  openArticleListDialog: PropTypes.func.isRequired,
  openSettingsDialog: PropTypes.func.isRequired,
  toggleProductDialog: PropTypes.func.isRequired,
  openReportDialog: PropTypes.func.isRequired,
  localSettings: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};


export default withStyles(styles)(PopUpMenu);
